module.exports = __webpack_public_path__ + "static/media/9D.1d495bb1.png";